import $http from '../../axios';
import {Notification} from 'element-ui';

/** Misma lógica que kardex: respuesta completa en state (incluye .data) */
export async function fetchBranchOffices({commit}) {
    await $http.get('/api/sedes')
        .then((response) => {
            commit('setBranchOffices', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box'
            });
        });
}

/** Misma lógica que kardex: query branchoffice_id en la URL */
export async function fetchBranchOfficeWarehouses({commit}, branchofficeId) {
    commit('clearParamsBranchofficesWarehouseId');

    await $http.get(`/api/bodegas-sedes?branchoffice_id=${branchofficeId}`)
        .then((response) => {
            commit('setBranchofficeWarehouses', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box'
            });
        });
}

/**
 *
 * @param dispatch
 * @param state
 * @param rootState
 * @param commit
 * @returns {Promise<void>}
 */
export async function fetchLines({dispatch, state, rootState, commit}) {
    await dispatch(
        'lines/fetchLines',
        {params: {paginate: false}},
        {root: true}
    );

    commit('setLines', rootState.lines.lines);
}

/**
 *
 * @param dispatch
 * @param state
 * @param rootState
 * @param commit
 * @returns {Promise<void>}
 */
export async function fetchBrands({dispatch, state, rootState, commit}) {
    await dispatch(
        'brands/fetchBrands',
        {
            params: {
                paginate: false,
                lines: []
            }
        },
        {root: true}
    );
    commit('setBrands', rootState.brands.brands);
}


/**
 *
 * @returns {Promise<void>}
 */
export async function reportGenerate({state, commit},download = false) {
    commit('setPreloader', true);
    if (download){
        state.params.download = true
    }
    state.loading.module = true;
    await $http({
        url: '/api/inventario-valorizado-wms',
        method: 'GET',
        responseType:state.params.download? 'blob':'Json',
        params: state.params
    })
        .then(response => {
            if (state.params.download){
                state.params.download = null
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Inventario-valorizado.csv');
                document.body.appendChild(link);
                link.click();
            }else{
                commit('setDataReport', response.data);
            }

        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        })
        .finally(() => {
            state.loading.module = false;
        });
    commit('setPreloader', false);
}



// WEBPACK FOOTER //
// ./src/modules/inventory-report-wms/actions.js